import { SidebarModule } from '@/config/permissions'
import {
  IconAddressBook,
  IconBroadcast,
  IconLayoutDashboard,
  IconMessages,
  IconPackages,
  IconRobot,
  IconRocket,
  IconSettings,
  IconTool,
  IconTournament,
  IconUsers
} from '@tabler/icons-react'
import { type SidebarData } from '../types'

export const sidebarData: SidebarData = {
  navGroups: [
    {
      title: 'General',
      items: [
        {
          title: 'Dashboard',
          url: '/',
          icon: IconLayoutDashboard,
          module: SidebarModule.DASHBOARD,
        },
        {
          title: 'Conexões',
          url: '/connections',
          icon: IconBroadcast,
        },
        {
          title: 'Bate Papo ao Vivo',
          url: '/chats',
          icon: IconMessages,
          module: SidebarModule.CHAT,
        },
      ],
    },
    {
      title: 'Gerenciar',
      items: [
        {
          title: 'Contatos',
          icon: IconAddressBook,
          items: [
            {
              title: 'Seus contatos',
              url: '/contacts',
            },
            {
              title: 'Segmentos',
              url: '/contacts/segment',
            },
          ],
        },
        {
          title: 'Atendentes',
          icon: IconUsers,
          module: SidebarModule.ATTENDANTS,
          items: [
            {
              title: 'Seus atendentes',
              url: '/attendants',
            },
            {
              title: 'Departamentos',
              url: '/attendants/departments',
              module: SidebarModule.DEPARTMENTS,
            },
          ],
        },
        {
          title: 'Agentes de IA',
          url: '/agents',
          icon: IconRobot,
          module: SidebarModule.AI_AGENTS,
        },
        {
          title: 'Automações',
          url: '/automations',
          icon: IconRocket,
          module: SidebarModule.AUTOMATIONS,
        },
        {
          title: 'Fluxos (em Breve)',
          url: '/flows',
          icon: IconTournament,
          disabled: import.meta.env.VITE_DEV_MODE !== 'true',
          module: SidebarModule.FLOWS,
        },
        {
          title: 'Integrações (em Breve)',
          url: '/apps',
          icon: IconPackages,
          disabled: import.meta.env.VITE_DEV_MODE !== 'true',
          module: SidebarModule.INTEGRATIONS,
        },
      ],
    },
    {
      title: 'Outros',
      items: [
        {
          title: 'Configurações',
          icon: IconSettings,
          module: SidebarModule.SETTINGS,
          items: [
            {
              title: 'Conta',
              url: '/settings/account',
              icon: IconTool,
            },
            // {
            //   title: 'Profile',
            //   url: '/settings',
            //   icon: IconUserCog,
            // },
            // {
            //   title: 'Appearance',
            //   url: '/settings/appearance',
            //   icon: IconPalette,
            // },
            // {
            //   title: 'Notifications',
            //   url: '/settings/notifications',
            //   icon: IconNotification,
            // },
            // {
            //   title: 'Display',
            //   url: '/settings/display',
            //   icon: IconBrowserCheck,
            // },
            {
              title: 'Configurações do Time',
              url: '/settings/team',
              icon: IconUsers,
            },
          ],
        },
      ],
    },
  ],
}
